export default __webpack_public_path__ + "static/media/vol3_3.671cf19c.png";